import axios from 'axios'
import router from '@/router'

const state = {
    idToken: localStorage.getItem('token') || null,
    userId: null,
    user: null
}

const mutations = {
    'AUTH_USER'(state, userData) {
        state.idToken = userData.token
        // state.userId = userData.userId
    },
    'STORE_USER'(state, user) {
        state.user = user
    },
    'CLEAR_AUTH_DATA'(state) {
        state.idToken = null
        state.userId = null
    },
    'GET_USER_DATA'(state, user) {
        let countries = []

        //Countries array formatten in goed formaat
        user.apps.forEach(num => {
            countries.push({
                id: num['id'],
                name: num['name'],
                order: num['order'],
                value: num['value'],
                checked: (num['name'] === 'AM') ? true : false
            })
        });

        let sales = []
        for (let key in user.sales) {
            sales.push(user.sales[key])
        }

        state.user = {
            user: user.user,
            countries: countries,
            roles: user.roles,
            sales: sales
        }
    },
    'UNCHECK_ALL_COUNTRIES'(state) {
        for (var key in state.user.countries) {
            if (state.user.countries[key].value !== '') {
                state.user.countries[key].checked = false
            }
        }
    },
    'UNCHECK_OVERVIEW'(state) {
        for (var key in state.user.countries) {
            if (state.user.countries[key].value === '') {
                state.user.countries[key].checked = false
            }
        }
    },
    'CHECK_OVERVIEW'(state) {
        state.user.countries[0].checked = true
    }
}

const actions = {
    //Login functie
    login({commit, dispatch}, authData) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'login', {
                email: authData.email,
                password: authData.password
            }).then((res) => {
                const expiresAt = res.data.success.expires_at
                const accessToken = res.data.success.token

                localStorage.setItem('token', accessToken)
                localStorage.setItem('expirationDate', expiresAt)
                commit('AUTH_USER', {
                    token: accessToken
                })
                // dispatch('userData')
                resolve(res)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
    //Default data ophalen na inlog
    userData: async ({commit, state}) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.idToken
        return axios.get(process.env.VUE_APP_API_URL + 'data')
            .then((res) => {
                commit('GET_USER_DATA', res.data)
                return true
            })
            //Opnieuw inloggen bij verkeerde token, bv aanmaken in localstorage
            .catch(error => {
                localStorage.removeItem('expirationDate')
                localStorage.removeItem('token')
                localStorage.removeItem('userId')
                state.idToken = null
                state.userId = null
                return false
            })
    },
    //Logout functie
    destroyToken(context) {
        if (context.getters.isAuthenticated) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API_URL + 'logout')
                    .then((res) => {
                        localStorage.removeItem('expirationDate')
                        localStorage.removeItem('token')
                        localStorage.removeItem('userId')
                        context.commit('CLEAR_AUTH_DATA')
                        router.push({name: 'login'})
                        resolve(res)
                    })
                    .catch(error => {
                        localStorage.removeItem('expirationDate')
                        localStorage.removeItem('token')
                        localStorage.removeItem('userId')
                        reject(error)
                    })
            })
        }
    },
    //Bij 401 (unauthorized), token enzo leegmaken
    interceptToken(context) {
        localStorage.removeItem('expirationDate')
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
        context.commit('CLEAR_AUTH_DATA')
        router.push({name: 'login'})
    },
    uncheckAllCountries(context) {
        context.commit('UNCHECK_ALL_COUNTRIES')
    },
    uncheckOverview(context) {
        context.commit('UNCHECK_OVERVIEW')
    },
    checkOverview(context) {
        context.commit('CHECK_OVERVIEW')
    },
    //Password email link request
    PASSWORD_FORGOT({commit, dispatch}, authData) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'password/email', {
                email: authData.email
            }).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
    //New password set
    PASSWORD_RESET({commit, dispatch}, payload) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'password/reset', {
                email: payload.email,
                token: payload.token,
                password: payload.password,
                password_confirmation: payload.password_confirmation
            }).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
}

const getters = {
    USER(state) {
        return state.user
    },
    isAuthenticated(state) {
        return state.idToken !== null
    },
    ROLES(state) {
        if(state.user.user.roles[0]){
            return state.user.user.roles[0].name
        }else{
            return null
        }

    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
